exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link i{color:#6c757d}.nav-link span{color:#2f2f28}.nav-link.menu span{color:#f2f2f2}.nav-link.menu.active span{color:#4976e8}.btn-primary .menu-text span{color:#fff}.btn-primary:hover .menu-text span{color:#fff}.nav-link:hover span,.nav-link:hover i{color:#234dd0}span#inactive_badge{color:#fff !important}.inactive_badge:hover span{color:#fff !important}.feeRate span{color:#212529 !important}.active span,.active i{color:#234dd0}.status-account-demo.btn span{padding-left:0;vertical-align:baseline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/layout/header.scss
// module id = 6363
// module chunks = 0